//  NEW ALL
import React from "react";
import Modal from "react-modal";
import {Button} from "../../common/Button/Button"
import ModalContent from "../../common/Modal/ModalContent";
import Spinner from "../../common/Spinner/Spinner";
import close_modal from "./../../assets/ic_close_wh.svg";
Modal.setAppElement("#root");


export default function DeleteConfirmModal(props) {

	return (
		<Modal
			isOpen={props.isOpen}
			onRequestClose={props.toggleModal}
			ariaHideApp={false}
		>
			<ModalContent className="general-modal">
				<div className="modal-header">
					<span className="modal-title">Delete Partner Name</span>
					<img
						alt="close"
						id="Close"
						src={close_modal}
						className="close modal-close"
						onClick={props.toggleModal}
					/>
				</div>
				<div className={`modal-body notes-trail-content conv-pl25 conv-pr25 custom-scrollbar ${props.isLoading && "set-opacity"}`}>
					{props.deletePendingPartnerModalLoading && <Spinner className="center"/>}
                    <div className="conv-mt10">
                        <p>Are you sure you want to delete the partner name ?</p>
                    </div>

                    <div style={{display:"flex", justifyContent:"flex-end", gap:"10px"}}>
                        <Button 
                            type="button" 
                            // disabled={props.deliveryMode === "Self-Served" ||props.isDisabled === "disabled"}
                            // className={`my-services-model-submit-btn conv-pr15 conv-pl15 conv-mt10 conv-mb10
                            // ${props.deliveryMode === "Self-Served" ||props.isDisabled === "disabled"?"disabled":""}`}
                            onClick={props.deleteApprove}
                            disabled={props.deletePendingPartnerModalLoading ? true : false}
                            >
                            Yes
                        </Button>

                        <Button 
                            type="button" 
                            // disabled={props.deliveryMode === "Self-Served" ||props.isDisabled === "disabled"}
                            // className={`my-services-model-submit-btn conv-pr15 conv-pl15 conv-mt10 conv-mb10
                            // ${props.deliveryMode === "Self-Served" ||props.isDisabled === "disabled"?"disabled":""}`}
                            onClick={props.toggleModal}
                            disabled={props.deletePendingPartnerModalLoading ? true : false}
                            >
                            No
                        </Button>
                    </div>
				</div>
					
			</ModalContent>
		</Modal>
	);
}
